/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ArrayOfTActExportRowDto,
    ArrayOfTActTableRowDto,
    CreatableTestingProgramBody,
    CreateTestingProgramsErrorPayload,
    GetTestingProgramsTestingProgramIdActivitiesParams,
    PartialTestingProgram,
    SimpleTestingControlListDto,
    SimpleTestingProgramListDto,
    TestingProgramId,
    TestingProgramViewDto,
    UpdateTestingProgramsErrorPayload,
    UpdateableTestingProgramBody,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getTestingProgramsTestingProgramIdActivities = (
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ArrayOfTActTableRowDto>> => {
    return axios.get(`/api/testing-programs/${testingProgramId}/activities`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetTestingProgramsTestingProgramIdActivitiesQueryKey = (
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams
) => {
    return [
        `/api/testing-programs/${testingProgramId}/activities`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetTestingProgramsTestingProgramIdActivitiesQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingProgramsTestingProgramIdActivitiesQueryKey(
            testingProgramId,
            params
        );

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramIdActivities>>
    > = ({ signal }) =>
        getTestingProgramsTestingProgramIdActivities(testingProgramId, params, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: testingProgramId !== null && testingProgramId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingProgramsTestingProgramIdActivitiesQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramIdActivities>>
    >;
export type GetTestingProgramsTestingProgramIdActivitiesQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdActivities<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params: undefined | GetTestingProgramsTestingProgramIdActivitiesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivities
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivities
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivities<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivities
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivities
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivities<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdActivities<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdActivitiesQueryOptions(
            testingProgramId,
            params,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingProgramsTestingProgramIdActivitiesSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
        >,
        TError = AxiosError<null>,
    >(
        testingProgramId: TestingProgramId,
        params?: GetTestingProgramsTestingProgramIdActivitiesParams,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivities
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingProgramsTestingProgramIdActivitiesQueryKey(
                testingProgramId,
                params
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
            >
        > = ({ signal }) =>
            getTestingProgramsTestingProgramIdActivities(
                testingProgramId,
                params,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingProgramsTestingProgramIdActivitiesSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramIdActivities>>
    >;
export type GetTestingProgramsTestingProgramIdActivitiesSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdActivitiesSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params: undefined | GetTestingProgramsTestingProgramIdActivitiesParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdActivitiesSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivities>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    params?: GetTestingProgramsTestingProgramIdActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivities
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdActivitiesSuspenseQueryOptions(
            testingProgramId,
            params,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getTestingProgramsTestingProgramIdActivitiesExport = (
    testingProgramId: TestingProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ArrayOfTActExportRowDto>> => {
    return axios.get(
        `/api/testing-programs/${testingProgramId}/activities/export`,
        options
    );
};

export const getGetTestingProgramsTestingProgramIdActivitiesExportQueryKey = (
    testingProgramId: TestingProgramId
) => {
    return [
        `/api/testing-programs/${testingProgramId}/activities/export`,
    ] as const;
};

export const getGetTestingProgramsTestingProgramIdActivitiesExportQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getTestingProgramsTestingProgramIdActivitiesExport
            >
        >,
        TError = AxiosError<null>,
    >(
        testingProgramId: TestingProgramId,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingProgramsTestingProgramIdActivitiesExportQueryKey(
                testingProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdActivitiesExport
                >
            >
        > = ({ signal }) =>
            getTestingProgramsTestingProgramIdActivitiesExport(
                testingProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            enabled:
                testingProgramId !== null && testingProgramId !== undefined,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdActivitiesExport
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingProgramsTestingProgramIdActivitiesExportQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getTestingProgramsTestingProgramIdActivitiesExport
            >
        >
    >;
export type GetTestingProgramsTestingProgramIdActivitiesExportQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdActivitiesExport<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesExport<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesExport<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdActivitiesExport<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdActivitiesExportQueryOptions(
            testingProgramId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingProgramsTestingProgramIdActivitiesExportSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getTestingProgramsTestingProgramIdActivitiesExport
            >
        >,
        TError = AxiosError<null>,
    >(
        testingProgramId: TestingProgramId,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdActivitiesExport
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingProgramsTestingProgramIdActivitiesExportQueryKey(
                testingProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdActivitiesExport
                >
            >
        > = ({ signal }) =>
            getTestingProgramsTestingProgramIdActivitiesExport(
                testingProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdActivitiesExport
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingProgramsTestingProgramIdActivitiesExportSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getTestingProgramsTestingProgramIdActivitiesExport
            >
        >
    >;
export type GetTestingProgramsTestingProgramIdActivitiesExportSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdActivitiesExportSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesExportSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdActivitiesExportSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdActivitiesExportSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdActivitiesExport>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdActivitiesExport
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdActivitiesExportSuspenseQueryOptions(
            testingProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getTestingProgramsTestingProgramId = (
    testingProgramId: TestingProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingProgramViewDto>> => {
    return axios.get(`/api/testing-programs/${testingProgramId}`, options);
};

export const getGetTestingProgramsTestingProgramIdQueryKey = (
    testingProgramId: TestingProgramId
) => {
    return [`/api/testing-programs/${testingProgramId}`] as const;
};

export const getGetTestingProgramsTestingProgramIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingProgramsTestingProgramIdQueryKey(testingProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>
    > = ({ signal }) =>
        getTestingProgramsTestingProgramId(testingProgramId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: testingProgramId !== null && testingProgramId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingProgramsTestingProgramIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>
>;
export type GetTestingProgramsTestingProgramIdQueryError = AxiosError<null>;

export function useGetTestingProgramsTestingProgramId<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingProgramsTestingProgramId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingProgramsTestingProgramId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramId<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingProgramsTestingProgramId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingProgramsTestingProgramId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramId<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramId<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTestingProgramsTestingProgramIdQueryOptions(
        testingProgramId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingProgramsTestingProgramIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingProgramsTestingProgramIdQueryKey(testingProgramId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>
    > = ({ signal }) =>
        getTestingProgramsTestingProgramId(testingProgramId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingProgramsTestingProgramIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>
>;
export type GetTestingProgramsTestingProgramIdSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingProgramsTestingProgramId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdSuspenseQueryOptions(
            testingProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteTestingProgramsTestingProgramId = (
    testingProgramId: TestingProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/testing-programs/${testingProgramId}`, options);
};

export const getDeleteTestingProgramsTestingProgramIdMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>,
        TError,
        { testingProgramId: TestingProgramId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>,
    TError,
    { testingProgramId: TestingProgramId },
    TContext
> => {
    const mutationKey = ["deleteTestingProgramsTestingProgramId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>,
        { testingProgramId: TestingProgramId }
    > = (props) => {
        const { testingProgramId } = props ?? {};

        return deleteTestingProgramsTestingProgramId(
            testingProgramId,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTestingProgramsTestingProgramIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>
>;

export type DeleteTestingProgramsTestingProgramIdMutationError =
    AxiosError<null>;

export const useDeleteTestingProgramsTestingProgramId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>,
            TError,
            { testingProgramId: TestingProgramId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteTestingProgramsTestingProgramId>>,
    TError,
    { testingProgramId: TestingProgramId },
    TContext
> => {
    return useMutation(
        getDeleteTestingProgramsTestingProgramIdMutationOptions(options),
        queryClient
    );
};
export const patchTestingProgramsTestingProgramId = (
    testingProgramId: TestingProgramId,
    updateableTestingProgramBody: UpdateableTestingProgramBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/testing-programs/${testingProgramId}`,
        updateableTestingProgramBody,
        options
    );
};

export const getPatchTestingProgramsTestingProgramIdMutationOptions = <
    TError = AxiosError<UpdateTestingProgramsErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>,
        TError,
        {
            testingProgramId: TestingProgramId;
            data: UpdateableTestingProgramBody;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>,
    TError,
    { testingProgramId: TestingProgramId; data: UpdateableTestingProgramBody },
    TContext
> => {
    const mutationKey = ["patchTestingProgramsTestingProgramId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>,
        {
            testingProgramId: TestingProgramId;
            data: UpdateableTestingProgramBody;
        }
    > = (props) => {
        const { testingProgramId, data } = props ?? {};

        return patchTestingProgramsTestingProgramId(
            testingProgramId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchTestingProgramsTestingProgramIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>
>;
export type PatchTestingProgramsTestingProgramIdMutationBody =
    UpdateableTestingProgramBody;
export type PatchTestingProgramsTestingProgramIdMutationError =
    AxiosError<UpdateTestingProgramsErrorPayload>;

export const usePatchTestingProgramsTestingProgramId = <
    TError = AxiosError<UpdateTestingProgramsErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>,
            TError,
            {
                testingProgramId: TestingProgramId;
                data: UpdateableTestingProgramBody;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchTestingProgramsTestingProgramId>>,
    TError,
    { testingProgramId: TestingProgramId; data: UpdateableTestingProgramBody },
    TContext
> => {
    return useMutation(
        getPatchTestingProgramsTestingProgramIdMutationOptions(options),
        queryClient
    );
};
export const getTestingProgramsTestingProgramIdTestingControls = (
    testingProgramId: TestingProgramId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SimpleTestingControlListDto>> => {
    return axios.get(
        `/api/testing-programs/${testingProgramId}/testing-controls`,
        options
    );
};

export const getGetTestingProgramsTestingProgramIdTestingControlsQueryKey = (
    testingProgramId: TestingProgramId
) => {
    return [
        `/api/testing-programs/${testingProgramId}/testing-controls`,
    ] as const;
};

export const getGetTestingProgramsTestingProgramIdTestingControlsQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
        >,
        TError = AxiosError<null>,
    >(
        testingProgramId: TestingProgramId,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingProgramsTestingProgramIdTestingControlsQueryKey(
                testingProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdTestingControls
                >
            >
        > = ({ signal }) =>
            getTestingProgramsTestingProgramIdTestingControls(
                testingProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            enabled:
                testingProgramId !== null && testingProgramId !== undefined,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdTestingControls
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingProgramsTestingProgramIdTestingControlsQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
        >
    >;
export type GetTestingProgramsTestingProgramIdTestingControlsQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdTestingControls<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdTestingControls<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdTestingControls<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdTestingControls<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdTestingControlsQueryOptions(
            testingProgramId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingProgramsTestingProgramIdTestingControlsSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
        >,
        TError = AxiosError<null>,
    >(
        testingProgramId: TestingProgramId,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingProgramsTestingProgramIdTestingControls
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingProgramsTestingProgramIdTestingControlsQueryKey(
                testingProgramId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdTestingControls
                >
            >
        > = ({ signal }) =>
            getTestingProgramsTestingProgramIdTestingControls(
                testingProgramId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingProgramsTestingProgramIdTestingControls
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingProgramsTestingProgramIdTestingControlsSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
        >
    >;
export type GetTestingProgramsTestingProgramIdTestingControlsSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingProgramsTestingProgramIdTestingControlsSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdTestingControlsSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsTestingProgramIdTestingControlsSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsTestingProgramIdTestingControlsSuspense<
    TData = Awaited<
        ReturnType<typeof getTestingProgramsTestingProgramIdTestingControls>
    >,
    TError = AxiosError<null>,
>(
    testingProgramId: TestingProgramId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingProgramsTestingProgramIdTestingControls
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingProgramsTestingProgramIdTestingControlsSuspenseQueryOptions(
            testingProgramId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getTestingPrograms = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SimpleTestingProgramListDto>> => {
    return axios.get(`/api/testing-programs`, options);
};

export const getGetTestingProgramsQueryKey = () => {
    return [`/api/testing-programs`] as const;
};

export const getGetTestingProgramsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getTestingPrograms>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTestingProgramsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingPrograms>>
    > = ({ signal }) => getTestingPrograms({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTestingPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingProgramsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingPrograms>>
>;
export type GetTestingProgramsQueryError = AxiosError<null>;

export function useGetTestingPrograms<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTestingPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getTestingPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingPrograms<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTestingPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getTestingPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingPrograms<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingPrograms<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTestingProgramsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingProgramsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getTestingPrograms>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTestingProgramsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingPrograms>>
    > = ({ signal }) => getTestingPrograms({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTestingPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingProgramsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingPrograms>>
>;
export type GetTestingProgramsSuspenseQueryError = AxiosError<null>;

export function useGetTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getTestingPrograms>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTestingProgramsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postTestingPrograms = (
    creatableTestingProgramBody: CreatableTestingProgramBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PartialTestingProgram>> => {
    return axios.post(
        `/api/testing-programs`,
        creatableTestingProgramBody,
        options
    );
};

export const getPostTestingProgramsMutationOptions = <
    TError = AxiosError<CreateTestingProgramsErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTestingPrograms>>,
        TError,
        { data: CreatableTestingProgramBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTestingPrograms>>,
    TError,
    { data: CreatableTestingProgramBody },
    TContext
> => {
    const mutationKey = ["postTestingPrograms"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTestingPrograms>>,
        { data: CreatableTestingProgramBody }
    > = (props) => {
        const { data } = props ?? {};

        return postTestingPrograms(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTestingProgramsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTestingPrograms>>
>;
export type PostTestingProgramsMutationBody = CreatableTestingProgramBody;
export type PostTestingProgramsMutationError =
    AxiosError<CreateTestingProgramsErrorPayload>;

export const usePostTestingPrograms = <
    TError = AxiosError<CreateTestingProgramsErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTestingPrograms>>,
            TError,
            { data: CreatableTestingProgramBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTestingPrograms>>,
    TError,
    { data: CreatableTestingProgramBody },
    TContext
> => {
    return useMutation(
        getPostTestingProgramsMutationOptions(options),
        queryClient
    );
};
